import React from 'react';
import { Container, Row, Col, Card, Badge, Alert } from 'react-bootstrap';
import './CookiePolicy.css';

function CookiePolicy() {
  return (
    <div className="diligencia-compliance-scope">
      {/* Hero Banner Section */}
      <div className="compliance-hero variant-amber">
        <div className="hero-overlay"></div>
        <Container className="hero-inner-container">
          <Badge className="compliance-badge badge-amber-color">
            <i className="fa-solid fa-cookie-bite badge-inline-icon"></i> Data Tracking
          </Badge>
          <h1 className="hero-heading">Cookie Policy</h1>
          <p className="hero-subtitle">
            Clear tracking analysis statements concerning how and why we implement technical cookies to optimize page interaction speeds.
          </p>
        </Container>
      </div>

      {/* Main Structural Core */}
      <Container className="content-container">
        
        {/* Core Description Unit */}
        <Row className="split-layout-row align-items-center-override">
          <Col xs={12} lg={7} className="split-column">
            <h2 className="section-main-title left-align">What Are Cookies?</h2>
            <div className="accent-bar-amber"></div>
            <p className="block-description-text font-15">
              Cookies are small text files stored safely on your computational node or handheld mobile device when visiting a website.
            </p>
            <p className="block-description-text font-15 no-margin">
              They allow web apps to store states and identify user navigation flows seamlessly, without altering localized device drivers.
            </p>
          </Col>
          <Col xs={12} lg={5} className="split-column">
            <div className="callout-box-amber">
              <i className="fa-solid fa-user-shield display-icon-amber"></i>
              <h4 className="callout-heading-amber">Encrypted Footprints</h4>
              <p className="callout-paragraph-amber">Cookies cannot inspect localized file hardware components or deliver virus tracking models.</p>
            </div>
          </Col>
        </Row>

        {/* How We Use Cookies Section */}
        <div className="secondary-section-wrapper">
          <div className="section-intro-block centered">
            <h3 className="sub-section-title">How We Use Cookies</h3>
            <p className="section-subtitle-text">We leverage data tracking elements strictly across the following fields:</p>
          </div>
          
          <Row className="commitments-row-grid">
            {[
              { title: "Website Functionality", desc: "Preserving interactive UI arrays, enabling session tokens, and stabilizing page configurations." },
              { title: "Performance Monitoring", desc: "Checking response timelines, assessing runtime scripts, and validating system rendering speeds." },
              { title: "Analytics & Traffic", desc: "Measuring baseline volume variables and tracking audience flows transparently." },
              { title: "UX Improvements", desc: "Remembering state criteria inputs to eliminate repeating selection pipelines." }
            ].map((pillar, idx) => (
              <Col key={idx} xs={12} sm={6} lg={3} className="grid-column-spacing">
                <Card className="pillar-metric-card">
                  <span className="watermark-number-label">0{idx+1}</span>
                  <Card.Body className="card-body-reset">
                    <h5 className="pillar-heading-title">{pillar.title}</h5>
                    <Card.Text className="pillar-description-text">{pillar.desc}</Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </div>

        {/* Types of Cookies Section */}
        <div className="secondary-section-wrapper">
          <h3 className="sub-section-title left-align">Types of Cookies</h3>
          
          <div className="tabular-stack-wrapper">
            {[
              { type: "Essential Cookies", label: "Required", class: "badge-slate", desc: "Required for basic website operation and security validation actions." },
              { type: "Analytics Cookies", label: "Optimization", class: "badge-blue", desc: "Used exclusively to help understand website usage patterns and internal path traversal structures." },
              { type: "Preference Cookies", label: "Personalization", class: "badge-emerald", desc: "Remember specialized user preferences, design variations, and active customized settings." }
            ].map((row, index) => (
              <Row key={index} className="tabular-item-row">
                <Col xs={12} md={4} className="tabular-meta-column">
                  <span className={`taxonomy-badge ${row.class}`}>{row.label}</span>
                  <h4 className="taxonomy-row-title">{row.type}</h4>
                </Col>
                <Col xs={12} md={8} className="tabular-body-column">
                  <p className="taxonomy-description-paragraph">{row.desc}</p>
                </Col>
              </Row>
            ))}
          </div>
        </div>

        {/* Managing Configurations Notice */}
        <Alert className="custom-danger-alert-banner">
          <div className="alert-flex-container">
            <div className="alert-icon-avatar-frame">
              <i className="fa-solid fa-gear"></i>
            </div>
            <div className="alert-content-frame">
              <h4 className="alert-main-title">Managing Cookies</h4>
              <p className="alert-description-text">
                Users may disable cookies at any moment through their specialized browser configurations or settings interfaces.
              </p>
              <div className="alert-inner-notice-box">
                <i className="fa-solid fa-triangle-exclamation notice-warning-icon"></i>
                <span className="notice-warning-text">
                  <strong>Notice:</strong> Please note that some core website functionality and page transitions may be affected or degraded if cookies are disabled.
                </span>
              </div>
            </div>
          </div>
        </Alert>

      </Container>
    </div>
  );
}

export default CookiePolicy;